// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".margin-top-8[data-v-b2c9d020] {\n  margin-top: 8px;\n}\n", ""]);
// Exports
module.exports = exports;
